var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-box",class:{ haspadding: _vm.hasPadding }},[_c('div',[_c('b-icon-trash',{staticClass:"plus icon"})],1),_c('div',{staticClass:"delete-text"},[_vm._v("Törlés")])])}
var staticRenderFns = []

export { render, staticRenderFns }